import React from 'react'
import NavbarMeganu from '../../../@shared/navigations/megamenu';
import { Footer } from '../../../@shared/footers';
import { Popularity } from './popularity';
import {SectionApp} from '../../../@shared/sections/hero/app'
import {HeroGreen} from '../../../@shared/sections/hero/green'
import {Featured} from './featured'

export const DirectoryPage = () => {

    return (
        <React.Fragment>
            <NavbarMeganu />
            <HeroGreen />
            <Featured />
            <Popularity />
            <SectionApp />
            <Footer />
        </React.Fragment>
    )
}

export default DirectoryPage;



